<!-- 预赛 -->
<template>
  <div class="mod pre-rank-score">
    <div class="mod__hd">
      <img src="../../../assets/img/base/title-pre-rank.png" alt="晋级名单" />
    </div>
    <div v-if="nowTime < preRes" class="mod_bd">
      <txt-wait-res :time="preRes" />
    </div>
    <div v-else-if="rank" class="mod_bd">
      <div class="mod__desc ta_center">
        <dl>
          <dd>初赛晋级决赛分数为<k-num-score :value="advanceScore" /><span v-if="preScore > 0">，你的得分<k-num-score :value="preScore" />，<k-txt-advance :value="isAdvance" /></span>
          </dd>
        </dl>
      </div>
      <div class="k-table k-table--rank skin-match">
        <table v-if="rank" cellspacing="0">
          <tr>
            <th class="fst">排名</th>
            <th class="ta_left">账号信息</th>
            <th class="lst">得分</th>
          </tr>
          <tr tag="tr" v-for="item in rank.list" :key="item.uid">
            <td class="rankNo">
              <k-num-rank :value="item.preRank" />
            </td>
            <td class="ta_left">
              <k-user :nick="item.mobile" :logo="item.logoSrc" />
            </td>
            <td class="score">{{item.preScore}}</td>
          </tr>
        </table>
      </div>
      <div class="k-page-bar">
        <k-pagination :page="1" :count="rank.maxPage" @change="change" />
      </div>
    </div>
    <div v-else class="mod_bd">
      <txt-loading />
    </div>
  </div>
</template>

<script>
  import {
    mapGetters
  } from 'vuex'
  export default {
    name: 'pre-rank-score',
    computed: {
      ...mapGetters(['nowTime', 'preRes', 'preRank', 'preScore', 'advanceScore', 'isAdvance']),
      ...mapGetters('match', {
        rank: 'preRankScore'
      })
    },
    methods: {
      change(page) {
        this.$emit("change", page)
      }
    }
  };

</script>
